<template>
	<div class="" v-if="queue">
		<h1 class="title">{{queue.DisplayName}}</h1>
		<p class="queue-help-text" >
			<span v-html="queue.HelpText"></span>
		</p>

		<div v-if="options.length > 0"> 
			<OptionList :options="options" :queue="queue"></OptionList>
		</div>
		<!-- <Login v-if="showLogin"
			:queue_id="queue.Id" 
			:login_call_name="queue.LoginCallName" 
			:login_legal_name="queue.LoginLegalName" 
			:login_student_number="queue.LoginStudentNumber" 
			:success_text="queue.SuccessText" >
		</Login> -->
		<Login 
			:api_root="api_root"
			:login_call_name="queue.LoginCallName" 
			:login_legal_name_first="queue.LoginLegalName1" 
			:login_legal_name_last="queue.LoginLegalName2" 
			:login_student_number="queue.LoginStudentNumber" 
			:login_netid="queue.LoginNetId" 
			:login_other="queue.LoginOther" 
			:login_other_text="queue.LoginOtherText" 
			:queue_id="queue.Id" 
			:success_text="queue.SuccessText" 
			v-if="showLogin">
		</Login>

	</div>
</template>

<script>
import Login from './Login';
import OptionList from './OptionList';
// import { EventBus } from '../event-bus.js';
export default {
	name: 'Queue',
	components: {
		'Login': Login,
		'OptionList': OptionList
	},
	props: [
		'api_root'
	],
	data () {
		return {
			error: null,
			loading: false,
			queue: null,
			options: []
		}
	},		
	mounted: function () {
		let self = this;
		self.getQueue(self.$route.params.queue_id);
		self.getOptions(self.$route.params.queue_id);
	},
	methods: {
		getQueue: function (id) {
			this.loading = true;
			var self = this;

			fetch(self.api_root + 'queuess/?Id=' + id, {
				method: "GET",
				headers: {
					'Access-Control-Allow-Origin': '*',
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Cache': 'no-cache'
				},
				credentials: "omit"
			})
			.then(function (response) {
				return response.json();
			})
			.then(function (response) {
				if (response) {
					if (typeof response.data[0] !== 'undefined') {
						self.queue = response.data[0];
					}
				} else {
					console.log(self.error, response.error);
					self.error = response.error;
				}
				self.loading = false;
			})
			.catch(function (error) {
				window.eventBus.$emit('fetchError', error);
			});
		},
		getOptions: function (id) {
			this.loading = true;
			var self = this;

			var url = self.api_root + 'optionss/?Active=1&Retired=0&QueueId=' + id;
			console.log(url);
			fetch(url, {
				method: "GET",
				headers: {
					'Access-Control-Allow-Origin': '*',
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Cache': 'no-cache'
				},
				credentials: "omit"
			})
			.then(function (response) {
				return response.json();
			})
			.then(function (response) {
				if (response) {
					self.options = response.data.sort(function(a, b) {return a.OrderNum > b.OrderNum});
				} else {
					console.log(self.error, response.error);
					self.error = response.error;
				}
				self.loading = false;
			})
			.catch(function (error) {
				window.eventBus.$emit('fetchError', error);
			});
		},
	},
	computed: {
		showLogin: function() {
			var self = this;
			return ((self.options.length == 0) && (self.queue.EnableLogin));
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.queue-help-text {
	margin-bottom:2rem;
}

</style>
